import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconPhoneCalling = (props: IconProps) => (
  <svg className={cn(iconStyles(props))} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path d="M21.956087 18.732979h0c.186516-.994766-.230924-2.006407-1.065805-2.579285l-2.843036-1.954892c-1.040937-.715876-2.444247-.587977-3.337747.304647-.974324.971673-2.525959 1.020523-3.574.128787-.487607-.414782-.968995-.857986-1.439726-1.327835-.469843-.471625-.91304-.952132-1.327816-1.439745-.891724-1.048056-.843763-2.599713.128785-3.57405.892612-.894401 1.020509-2.296843.304643-3.337794L6.84652 2.10885C6.27276 1.274845 5.262023.857399 4.266383 1.043917c-.797578.150991-1.479693.539127-2.022366 1.081807-2.74356 2.744487-.797578 9.13852 4.34671 14.283767 5.145175 5.144358 11.539119 7.090368 14.283568 4.345881.542672-.541792.930803-1.224805 1.081792-2.022393zM13 5c2.208896 0 4 1.791104 4 4M14 1c3.865634 0 7 3.133532 7 7" />
    </g>
  </svg>
);
